<template>
  <div
    class="ts-flex ts-items-center ts-justify-between ts-py-3 ts-px-3 ts-rounded-lg ts-relative ts-cursor-pointer"
    style="background: rgba(146, 146, 146, 0.3); box-shadow: 0px 19px 4px -12px #00000023;border:1px solid transparent"
    :style="
      selected
        ? 'background: ' +
          bgSelected +
          ';border:1px solid rgba(146, 146, 146, 0.3)'
        : ''
    "
  >
    <strong class="ts-text-base ts-tracking-wider" style="color: #464a52;">{{
      title
    }}</strong>
    <div class="ts-flex ts-absolute ts-right-0 ts-space-x-4 ts--mr-4">
      <div
        class="ts-mb-0 ts-h-6 ts-w-12 ts-flex ts-items-center ts-justify-center  ts-rounded-bl ts-rounded-tl"
        :class="[bgBadgeColor]"
      >
        <b class="ts-text-lg" :class="[textColor]">{{ numberTask }}</b>
      </div>
      <div
        class="ts-mb-0 ts-h-6 ts-w-4 ts-flex ts-items-center ts-justify-center"
        :class="[bgBadgeColor]"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    numberTask: {
      type: Number,
      default: () => 0
    },
    bgBadgeColor: {
      type: String,
      default: () => 'ts-bg-pink-700'
    },
    textColor: {
      type: String,
      default: () => 'ts-text-white'
    },
    selected: {
      type: Boolean,
      default: () => false
    },
    bgSelected: {
      type: String
    }
  }
}
</script>
<style scoped>
* {
  font-family: Roboto, Khmer;
}
</style>
